import {GET_DESIGNER_REQUESTED, EDIT_DESIGNER_REQUESTED, DELETE_DESIGNER_REQUESTED} from './edit.actions';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import store from './../../../store/store.module';
import {GET_ALL_SIZES_REQUESTED} from "../../size/size.actions";
import {GET_SIZE_CONVERSION_REQUESTED} from "../../size/list/list.actions";
import {FETCH_CONSTANTS_REQUESTED} from "../../../store/constant/list/list.actions";
import {GET_ALL_CATEGORIES_REQUESTED} from "../../category/category.actions";

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditComponent implements OnInit {
  public store = store;
  public designer;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    store.dispatch({
      type: GET_DESIGNER_REQUESTED,
      data: this.getDesignerId()
    });
    store.dispatch({
      type: GET_ALL_SIZES_REQUESTED
    });
    store.dispatch({ type: GET_ALL_CATEGORIES_REQUESTED });
    store.dispatch({ type: GET_SIZE_CONVERSION_REQUESTED });
    store.dispatch({ type: FETCH_CONSTANTS_REQUESTED });
    let unsubscribe = store.subscribe(() => {
      if ((store as any).getState().Designer.edit.fetched) {
        this.designer = (store as any).getState().Designer.edit.item;
        this.designer.sizes = this.designer.sizes.map((s, key) => {
          s.standard_size = null;
          if (s.size_designer) {
            s.standard_size = s.size_designer.standard_size;
          }
          s.unique_id = key;
          return s;
        });
        unsubscribe();
      }
    });
  }

  onSubmit(form) {
    if (form.valid) {
      store.dispatch({
        type: EDIT_DESIGNER_REQUESTED,
        data: this.designer
      });
    }
  }

  getDesignerId() {
    return this.route.snapshot.paramMap.get('id');
  }

  deleteItem() {
    store.dispatch({type: DELETE_DESIGNER_REQUESTED, data: this.getDesignerId()});
  }

  deleteOwnSizeItem(size_id) {
    this.designer.sizes = this.designer.sizes.filter(s => s.unique_id !== size_id);
  }

  addOwnSizeItem(type) {
    this.designer.sizes = [
      ...this.designer.sizes,
      {
        unique_id: Number.MAX_SAFE_INTEGER - this.designer.sizes.length,
        id: '',
        standard_size: null,
        age_group: '',
        gender: '',
        type
      }
    ];
  }
}
